'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
require('../css/index.scss');
var _player = require('./player');
var _player2 = _interopRequireDefault(_player);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
console.log('\n' + ' %c DPlayer v' + DPLAYER_VERSION + ' ' + GIT_HASH + ' %c http://dplayer.js.org ' + '\n' + '\n', 'color: #fadfa3; background: #030307; padding:5px 0;', 'background: #fadfa3; padding:5px 0;');
exports.default = _player2.default;


//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 1
// module chunks = 0